const contents = [
    {
        title: 'How is my information protected?',
        content: (
            <p>PowerPlay Systems maintains a comprehensive security program based on industry standards and best practices. All confidential consumer information is safeguarded by SSL (Secure Socket Layer), as represented by the padlock visible on your browser’s address tab.</p>
        )
    },
    {
        title: 'How do I protect my account?',
        content: (
            <ul>
                <li>Change your password every few months</li>
                <li>Never share your password with anyone</li>
                <li>Powerplay Systems will never ask you for your password</li>
                <li>Don’t use the same password on multiple sites</li>
                <li>Select strong passwords that can’t be easily guessed</li>
                <li>Sign out of your account if you are using a shared computer</li>
                <li>Keep your antivirus software up to date</li>
            </ul>
        )
    },
    {
        title: 'Can I share my account with another person?',
        content: (
            <p>We strongly suggest that no other person have access to your account information. All activity in your account is your responsibility and only the account holder is authorized to operate an associated Powerplay Systems account. Only the account holder may contact us regarding an account.</p>
        )
    },
    {
        title: 'What should I do if my account has been misallocated, compromised or otherwise mishandled?',
        content: (
            <p>If you believe your account has been misallocated, compromised or mishandled please contact support support@powerplaysystems.com for assistance. Please provide all pertinent information related to your claim and a dedicated member of our Customer Service team will address your support ticket within 24 hours. If your support ticket cannot be resolved to your satisfaction by a Customer Service Representative, you may request escalation of the ticket to a Customer Service Supervisor. For additional consumer protection information, visit the Federal Trade Commission’s consumer protection page.</p>
        )
    }
]

export default contents;